export var FLEX_LAYOUT_CLASS_NAME = '';